module.exports = __webpack_public_path__ + "68b40861661ca4824f9849bb91d40185.png";